export const QueryKeys = {
  CATEGORIES: "CATEGORIES",
  POSTS: "POSTS",
  POSTDETAILS: "POSTDETAILS",
  SETTING: "SETTING",
  CMSPage: "CMSPage",
  MY_POSTS: "MY_POSTS",
  ADS: "ADS",
};
